<section id="Portfolio" class="section content-area bg-grey ptb_150">
    <!-- Shape Top -->
    <div class="shape shape-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
        c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
        c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12 col-lg-6">
                <!-- Content Inner -->
                <div class="content-inner text-center">
                    <!-- Section Heading -->
                    <div class="section-heading text-center mb-3">
                        <h3>Nous aidons à développer votre entreprise.</h3>
                        <p class="d-none d-sm-block mt-4">Fondée en 2020, la société d'Innovation et des Solutions Technologiques/Innovation and technological Solution Company ITSC a été crée en pleine pandemie. Malgré tous les conditions dificiles, la société continue à travailler sur les projets de ces clients et aussi sur les projets internes innovants. Nous sommes une équipe trés polyvalente. Peu importe votre besoin, nous sommes prêts à entrer dans un nouveau défi avec vous. Notre but c'est votre satisfaction. </p>
                        <p class="d-block d-sm-none mt-4">Nous sommes une équipe trés polyvalente. Peu importe votre besoin, nous sommes prêts à entrer dans un nouveau défi avec vous. Notre but c'est votre satisfaction.</p>
                    </div>
                    <!-- Content List -->
                    <ul class="content-list text-left">
                        <!-- Single Content List -->
                        <li class="single-content-list media py-2">
                            <div class="content-icon pr-4">
                                <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                            </div>
                            <div class="content-text media-body">
                                <span><b>Présence 7/7</b><br>Nous sommes disponibles chaque jour et même les fins de semaine.</span>
                            </div>
                        </li>
                        <!-- Single Content List -->
                        <li class="single-content-list media py-2">
                            <div class="content-icon pr-4">
                                <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                            </div>
                            <div class="content-text media-body">
                                <span><b>À l'heure</b><br>Nous travaillons avec la méthodologie Agile (scrum). Cela nous aide à respecter les échanciers et nous essayons de livrer vos projets le plus vite possible en assurant une bonne qualité de service et une adaptation facile et rapide.</span>
                            </div>
                        </li>
                        <!-- Single Content List -->
                        <li class="single-content-list media py-2">
                            <div class="content-icon pr-4">
                                <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                            </div>
                            <div class="content-text media-body">
                                <span><b>Confiance</b><br>Notre premier objectif est de gagner votre confiance.</span>
                            </div>
                        </li>
                    </ul>
                    <!-- <a href="#" class="btn btn-bordered mt-4">Learn More</a> -->
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <!-- Service Thumb -->
                <div class="service-thumb mx-auto pt-4 pt-lg-0">
                    <img src="assets/img/newImg/growYourBusiness.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <!-- Shape Bottom -->
    <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
</section>